var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"data-cy":_vm.commonCy.SINGLE_ORDER.MANAGE_ORDER.BUTTON__APPROVE},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" "+_vm._s(_vm.isPrimary ? 'Approve Order' : 'Approve')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }